var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayout2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 147,
    viewBox: "0 0 183 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 182.173,
    height: 147,
    rx: 2,
    fill: "#F4F5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2793,
    y: 19.0723,
    width: 125.614,
    height: 121.01,
    rx: 4,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.46,
    y: 24.3335,
    width: 23.676,
    height: 5.26132,
    rx: 2,
    fill: "#DADBDD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.46,
    y: 110.488,
    width: 23.676,
    height: 5.26132,
    rx: 2,
    fill: "#DADBDD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.96,
    y: 34.6987,
    width: 31.8833,
    height: 31.8833,
    rx: 1.5,
    fill: "white",
    stroke: "#6D788C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39.96,
    y: 70.2126,
    width: 31.8833,
    height: 31.8833,
    rx: 1.5,
    fill: "white",
    stroke: "#DADBDD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 39.96,
    y: 118.88,
    width: 67.3972,
    height: 8.20732,
    rx: 1.5,
    fill: "white",
    stroke: "#DADBDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.569 122.326L102.924 123.97L101.28 122.326",
    stroke: "#DADBDD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 75.4736,
    y: 34.6987,
    width: 31.8833,
    height: 31.8833,
    rx: 1.5,
    fill: "white",
    stroke: "#DADBDD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 75.4736,
    y: 70.2126,
    width: 31.8833,
    height: 31.8833,
    rx: 1.5,
    fill: "white",
    stroke: "#DADBDD"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 110.988,
    y: 34.6987,
    width: 31.8833,
    height: 31.8833,
    rx: 1.5,
    fill: "white",
    stroke: "#DADBDD"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7212,
    y: 46.6943,
    width: 22.3606,
    height: 4.60366,
    rx: 2,
    fill: "#DADBDD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7212,
    y: 81.5505,
    width: 22.3606,
    height: 4.60366,
    rx: 2,
    fill: "#DADBDD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2354,
    y: 46.6943,
    width: 22.3606,
    height: 4.60366,
    rx: 2,
    fill: "#DADBDD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2354,
    y: 81.5505,
    width: 22.3606,
    height: 4.60366,
    rx: 2,
    fill: "#DADBDD"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 115.749,
    y: 46.6943,
    width: 22.3606,
    height: 4.60366,
    rx: 2,
    fill: "#DADBDD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3252,
    y: 53.271,
    width: 13.1533,
    height: 1.973,
    rx: 0.986498,
    fill: "#DADBDD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3252,
    y: 88.1272,
    width: 13.1533,
    height: 1.973,
    rx: 0.986498,
    fill: "#DADBDD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 42.748,
    y: 122.326,
    width: 36.1716,
    height: 1.973,
    rx: 0.986498,
    fill: "#DADBDD"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 84.8389,
    y: 53.271,
    width: 13.1533,
    height: 1.973,
    rx: 0.986498,
    fill: "#DADBDD"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 84.8389,
    y: 88.1272,
    width: 13.1533,
    height: 1.973,
    rx: 0.986498,
    fill: "#DADBDD"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 120.353,
    y: 53.271,
    width: 13.1533,
    height: 1.973,
    rx: 0.986498,
    fill: "#DADBDD"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2793,
    y: 8.54956,
    width: 29.5949,
    height: 5.26132,
    rx: 2,
    fill: "#6D788C"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5054,
    y: 8.54956,
    width: 29.5949,
    height: 5.26132,
    rx: 2,
    fill: "#DADBDD"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 92.0732,
    y: 8.54956,
    width: 29.5949,
    height: 5.26132,
    rx: 2,
    fill: "#DADBDD"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 124.299,
    y: 8.54956,
    width: 29.5949,
    height: 5.26132,
    rx: 2,
    fill: "#DADBDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout2);
export default __webpack_public_path__ + "static/media/layout2.cb597ab2d392e2ab824c64a427b54aa0.svg";
export { ForwardRef as ReactComponent };